import { graphql } from 'gql';

export const bimcCalculationDefaultsGql = graphql(`
    query bimcCalculationDefaults($projectUniqueId: String!) {
        bimcCalculationDefaults(projectUniqueId: $projectUniqueId) {
            data {
                authoredBy
                contractType
                customer
                costRounding
                supplyBasis
                taxPercent
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimcCalculationGql = graphql(`
    query bimcCalculation($calculationId: Long!) {
        bimcCalculation(calculationId: $calculationId) {
            data {
                authoredBy
                changeDate
                constructionTypes {
                    id
                    name
                    coefficients {
                        kozp
                        kemm
                        kzpm
                        kmtr
                        keqp
                        kmz
                        koz
                        knr
                        ksp
                        kpir
                    }
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                }
                contractType
                createdAt
                customer
                customerAddress
                id
                lastComputedAt
                nmcWithNmdc
                nmcWithoutNmdc
                nmdc
                taxPercent
                note
                projectUniqueId
                costRounding
                seasons {
                    inflation
                    id
                    isActive
                    year
                }
                seasonsInflation {
                    inflation
                    year
                }
                startDate
                status
                subject
                supplyBasis
                uniqueId
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimcCalculationSeasonsGql = graphql(`
    query bimcCalculationSeasons($calculationId: Long!) {
        bimcCalculationSeasons(calculationId: $calculationId) {
            id
            year
            inflation
            isActive
        }
    }
`);

export const bimcCreateCalculationGql = graphql(`
    mutation bimcCreateCalculation($input: BimcCalculationCreateInput!) {
        bimcCreateCalculation(input: $input) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimcUpdateCalculationGql = graphql(`
    mutation bimcUpdateCalculation($calculationInput: BimcCalculationUpdateInput!) {
        bimcUpdateCalculation(calculationInput: $calculationInput) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimcCalculationObjectsGql = graphql(`
    query bimcCalculationObjects($calculationId: Long!, $constructionTypeId: Long) {
        bimcCalculationObjects(calculationId: $calculationId, constructionTypeId: $constructionTypeId) {
            calculationId
            hasGuaranteedVolume
            id
            name
            order
            parentId
            codeWBS
            constructionTypeId
            rootObjectId
            seasons {
                calculationSeasonId
                id
                percent
                year
            }
        }
    }
`);

export const bimcCreateCalculationObjectGql = graphql(`
    mutation bimcCreateCalculationObject($input: BimcCalculationObjectCreateInput!) {
        bimcCreateCalculationObject(input: $input) {
            id
            result
        }
    }
`);

export const bimcCreateCalculationSubObjectGql = graphql(`
    mutation bimcCreateCalculationSubObject($input: BimcCalculationSubObjectCreateInput!) {
        bimcCreateCalculationSubObject(input: $input) {
            id
            result
        }
    }
`);

export const bimcUpdateCalculationObjectGql = graphql(`
    mutation bimcUpdateCalculationObject($input: BimcCalculationObjectUpdateInput!) {
        bimcUpdateCalculationObject(input: $input) {
            result
        }
    }
`);

export const bimcUpdateSeasonDistributionGql = graphql(`
    mutation bimcUpdateSeasonDistribution($calculationId: Long!, $items: [CalculationObjectSeasonDistributionInput!]!) {
        bimcUpdateSeasonDistribution(calculationId: $calculationId, items: $items)
    }
`);

export const bimcRemoveCalculationObjectGql = graphql(`
    mutation bimcRemoveCalculationObject($objectId: Long!) {
        bimcRemoveCalculationObject(objectId: $objectId) {
            result
        }
    }
`);

export const bimcIsUniqueCalculationObjectNameGql = graphql(`
    query bimcIsUniqueCalculationObjectName($calculationId: Long!, $name: String!, $excludeObjectId: Long) {
        bimcIsUniqueCalculationObjectName(calculationId: $calculationId, name: $name, excludeObjectId: $excludeObjectId)
    }
`);

export const bimcIsUniqueCalculationSubObjectNameGql = graphql(`
    query bimcIsUniqueCalculationSubObjectName($calculationObjectId: Long!, $name: String!, $excludeObjectId: Long) {
        bimcIsUniqueCalculationSubObjectName(
            calculationObjectId: $calculationObjectId
            name: $name
            excludeObjectId: $excludeObjectId
        )
    }
`);

export const bimcIsUniqueCalculationObjectCodeGql = graphql(`
    query bimcIsUniqueCalculationObjectCode($calculationId: Long!, $code: String!, $excludeObjectId: Long) {
        bimcIsUniqueCalculationObjectCode(calculationId: $calculationId, code: $code, excludeObjectId: $excludeObjectId)
    }
`);

export const bimcSetCalculationObjectGuaranteedVolumeGql = graphql(`
    mutation bimcSetCalculationObjectGuaranteedVolume($input: CalculationObjectGuaranteedVolumeInput!) {
        bimcSetCalculationObjectGuaranteedVolume(input: $input)
    }
`);

export const bimcImportCalculationStructureGql = graphql(`
    mutation bimcImportCalculationStructure($calculationId: Long!, $fileContent: FileInput!) {
        bimcImportCalculationStructure(calculationId: $calculationId, fileContent: $fileContent) {
            buttonText
            code
            data {
                count
            }
            message
            result
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

// export const uercCalculationObjectsGql = graphql(`
//     query uercCalculationObjects($calculationId: Long!, $constructionTypeId: Long) {
//         uercCalculationObjects(calculationId: $calculationId, constructionTypeId: $constructionTypeId) {
//             codeWBS
//             calculationId
//             constructionType {
//                 code
//                 description
//                 id
//                 name
//                 shortName
//             }
//             hasGuaranteedVolume
//             id
//             name
//             order
//             parentId
//             rootObjectId
//             hasWorItems
//         }
//     }
// `);

// export const uercCreateCalculationObjectGql = graphql(`
//     mutation uercCreateCalculationObject($input: CalculationObjectCreateInput!) {
//         uercCreateCalculationObject(input: $input) {
//             id
//             result
//             message
//             buttonText
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercCreateCalculationSubObjectGql = graphql(`
//     mutation uercCreateCalculationSubObject($input: CalculationSubObjectCreateInput!) {
//         uercCreateCalculationSubObject(input: $input) {
//             id
//             result
//             message
//             buttonText
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercRemoveCalculationObjectGql = graphql(`
//     mutation uercRemoveCalculationObject($calculationObjectId: Long!) {
//         uercRemoveCalculationObject(calculationObjectId: $calculationObjectId) {
//             buttonText
//             code
//             hasValidation
//             hideValidation
//             message
//             result
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercIsUniqueCalculationObjectNameGql = graphql(`
//     query uercIsUniqueCalculationObjectName(
//         $calculationId: Long!
//         $constructionTypeId: Int!
//         $calculationObjectId: Long
//         $name: String!
//     ) {
//         uercIsUniqueCalculationObjectName(
//             calculationId: $calculationId
//             constructionTypeId: $constructionTypeId
//             calculationObjectId: $calculationObjectId
//             name: $name
//         ) {
//             buttonText
//             code
//             result
//             message
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercIsUniqueCalculationSubObjectNameGql = graphql(`
//     query uercIsUniqueCalculationSubObjectName($calculationObjectId: Long!, $name: String!, $subObjectId: Long) {
//         uercIsUniqueCalculationSubObjectName(
//             calculationObjectId: $calculationObjectId
//             name: $name
//             subObjectId: $subObjectId
//         ) {
//             buttonText
//             code
//             result
//             message
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercIsUniqueCalculationObjectCodeGql = graphql(`
//     query uercIsUniqueCalculationObjectCode($calculationId: Long!, $calculationObjectId: Long, $code: String) {
//         uercIsUniqueCalculationObjectCode(
//             calculationId: $calculationId
//             calculationObjectId: $calculationObjectId
//             code: $code
//         ) {
//             actionRequired
//             buttonText
//             code
//             hasValidation
//             hideValidation
//             message
//             result
//             validation {
//                 message
//                 metadata
//                 property
//             }
//         }
//     }
// `);

// export const uercUpdateCalculationObjectGql = graphql(`
//     mutation uercUpdateCalculationObject($input: CalculationObjectUpdateInput!) {
//         uercUpdateCalculationObject(input: $input) {
//             buttonText
//             code
//             result
//             message
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercUpdateCalculationSubObjectGql = graphql(`
//     mutation uercUpdateCalculationSubObject($input: CalculationObjectUpdateInput!) {
//         uercUpdateCalculationSubObject(input: $input) {
//             buttonText
//             code
//             result
//             message
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercSetCalculationObjectGuaranteedVolumeGql = graphql(`
//     mutation uercSetCalculationObjectGuaranteedVolume($input: CalculationObjectGuaranteedVolumeInput!) {
//         uercSetCalculationObjectGuaranteedVolume(input: $input) {
//             buttonText
//             code
//             data
//             message
//             result
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

// export const uercImportCalculationObjectsGql = graphql(`
//     mutation uercImportCalculationObjects($calculationId: Long!, $fileContent: FileInput!) {
//         uercImportCalculationObjects(calculationId: $calculationId, fileContent: $fileContent) {
//             buttonText
//             code
//             data {
//                 count
//             }
//             message
//             result
//             hasValidation
//             hideValidation
//             validation {
//                 property
//                 message
//             }
//         }
//     }
// `);

export const bimcMoveCalculationObjectGql = graphql(`
    mutation bimcMoveCalculationObject($input: CalculationObjectMoveInput!) {
        bimcMoveCalculationObject(input: $input)
    }
`);

// export const uercCalculationConstructionTypesGql = graphql(`
//     query uercCalculationConstructionTypes($calculationId: Long!) {
//         uercCalculationConstructionTypes(calculationId: $calculationId) {
//             id
//             code
//             name
//             shortName
//             description
//         }
//     }
// `);

// export const uercCalculationObjectsWithVolumesGql = graphql(`
//     query uercCalculationObjectsWithVolumes($calculationId: Long!, $constructionTypeId: Long!) {
//         uercCalculationObjectsWithVolumes(calculationId: $calculationId, constructionTypeId: $constructionTypeId) {
//             id
//             name
//             order
//             parentId
//             rootObjectId
//         }
//     }
// `);

// export const uercCopyCalculationObjectGql = graphql(`
//     mutation uercCopyCalculationObject($input: CalculationObjectCopyInput!) {
//         uercCopyCalculationObject(input: $input) {
//             result
//             message
//             id
//         }
//     }
// `);
